import Form, { FormInstance } from 'antd/lib/form'
import Col from 'antd/lib/grid/col'
import Row from 'antd/lib/grid/row'
import Input from 'antd/lib/input'
import Radio from 'antd/lib/radio'
import { ActionButton } from 'Components/common/ActionButton/ActionButton'
import { useEffect, useMemo } from 'react'
import classes from './TurnPrimaryResponse.module.less'
import { PrimaryResponseFormType } from 'Types/Tasks.types'

type TurnPrimaryResponsePropsType = {
    form: FormInstance<PrimaryResponseFormType>
    setPrimaryResponseForm: (form: FormInstance<PrimaryResponseFormType>) => void
    onClickProceed: () => void
    disabled: boolean
    isReviewMode?: boolean
    initialValues?: {
        isCorrect: boolean
        followInstructions: boolean
        skillsUsed: string
        skillsGap: string
    }
}

export const TurnPrimaryResponse = (props: TurnPrimaryResponsePropsType) => {
    const { form, onClickProceed, disabled, isReviewMode, setPrimaryResponseForm } = props
    const initialValues = useMemo(
        () => ({
            isCorrect: true,
            followInstructions: true,
            skillsUsed: 'YES',
            skillsGap: '',
        }),
        []
    )

    useEffect(() => {
        setPrimaryResponseForm(form)
    }, [form, setPrimaryResponseForm])

    return (
        <div className={classes.section}>
            <p className={classes.title}>Section 1: FILL THE BELOW DETAILS</p>

            <Form
                form={form}
                layout="vertical"
                initialValues={props.initialValues ?? initialValues}
                disabled={disabled}
                onFinish={onClickProceed}
            >
                <Row>
                    <Col>
                        <Form.Item<PrimaryResponseFormType>
                            name="isCorrect"
                            label="Is the model response correct?"
                        >
                            <Radio.Group disabled={isReviewMode}>
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item<PrimaryResponseFormType>
                            name="followInstructions"
                            label="Does the response follow all instructions?"
                        >
                            <Radio.Group>
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Item<PrimaryResponseFormType>
                            name="skillsUsed"
                            label="Are the selected skills used in the response?"
                        >
                            <Radio.Group>
                                <Radio value={'YES'}>Yes</Radio>
                                <Radio value={'NO'}>No</Radio>
                                <Radio value={'SOME'}>Only some</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Item<PrimaryResponseFormType> name="skillsGap" label="Skills gap">
                            <Input className={classes.input} placeholder="Enter skills gap" />
                        </Form.Item>
                    </Col>
                </Row>

                {!disabled && !isReviewMode && (
                    <ActionButton
                        color="primary"
                        title={'Proceed'}
                        style={{ margin: 0, borderRadius: 4, width: '150px' }}
                        onClick={() => form.submit()}
                    />
                )}
            </Form>
        </div>
    )
}
